export const INTERVIEW_FORMAT_MODEL = "interview-format";

import {
  INTERVIEW_SLOT_MODEL,
  INTERVIEW_SLOTS_UNFILLED_MODEL
} from "@/models/interview-slot-model";

const interviewFormatModel = {
  interviewName: "",
  interviewerDetails: "",
  candidateDetails: "",
  duration: 0,
  interviewSlots: {
    jsonApi: "hasMany",
    type: INTERVIEW_SLOT_MODEL
  },
  interviewSlotsUnfilled: {
    jsonApi: "hasMany",
    type: INTERVIEW_SLOTS_UNFILLED_MODEL
  },
  candidates: [],
  interviewers: [],
  booking: {
    jsonApi: "hasOne",
    type: "bookings"
  }
};

export default interviewFormatModel;
